// extracted by mini-css-extract-plugin
module.exports = {"loaderSpinner":"Loader_loaderSpinner__34VrC","load8":"Loader_load8__s3KeB","positionAbsolute":"Loader_positionAbsolute__2dzPm"};